export default __webpack_public_path__ + "static/media/fmd_blue.c8f4c1ae.svg";